<template>

<core-modal v-on:close="onClose" :icon="(data.manage) ? 'caret-left' : false">

	<template v-slot:head>

		Create Tag Family

	</template>

	<template v-slot:default>

		<core-form-input-textbox :autofocus="true" maxlength="16" name="text" v-on:validate="validate" placeholder="Enter name" v-model="inputs.name" notes="Maximum of 16 characters." :error="is.error" :disabled="is.loading" :validation="validation.name" />

		<core-form-input-togglelist title="Type" name="type" v-on:validate="validate" v-model="inputs.type" :error="is.error" :disabled="is.loading" :validation="validation.type" :options="typeOptions" />

		<core-form-input-togglelist title="Style" name="style" v-on:validate="validate" v-model="inputs.style" :error="is.error" :disabled="is.loading" :validation="validation.style" :options="styleOptions" />

		<core-form-input-colourpicker title="Background" name="colour" v-on:validate="validate" v-model="inputs.colour" :error="is.error" :disabled="is.loading" :validation="validation.colour" v-if="inputs.style" />

		<core-form-input-colourpicker title="Text" name="fore" v-on:validate="validate" v-model="inputs.fore" :error="is.error" :disabled="is.loading" :validation="validation.fore" :is-text="true" v-if="inputs.style" />

		<core-form-input-togglelist title="Seen by" name="public" v-on:validate="validate" v-model="inputs.public" :error="is.error" :disabled="is.loading" :validation="validation.public" :options="publicOptions" />

		<core-form-input-togglelist title="Attaches to" name="context" v-on:validate="validate" v-model="inputs.context" :error="is.error" :disabled="is.loading" :validation="validation.context" :options="contextOptions" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!inputs.name">Confirm</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	props: ['data'],
	
	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			inputs: {
				name: '',
                type: 0,
                style: 1,
				public: 1,
				context: 0,
                colour: '#134677',
                fore: '#ffffff'
			},

			validation: {
				name: {
					exists: true,
					max: 16
				}
			}

		}

	},

	computed: {

		typeOptions: function() {

			return [{
				value: 1,
				title: 'Exclusive',
				text: 'Only one tag from this tag family can be attached to an item.'
			}, {
				value: 0,
				title: 'Multiple',
				text: 'More than one tag from this tag family can be attached to an item.'
			}]

		},

		publicOptions: function() {

			return [{
				value: 1,
				title: 'Everyone',
				text: 'Anyone viewing your profile can see this tag family and filter with it.'
			}, {
				value: 0,
				title: 'Only me',
				text: 'Only you can see this tag family and filter with it.'
			}]

		},

		styleOptions: function() {

			return [{
				value: 1,
				title: 'Family style',
				text: 'Every tag in the family has the same colours.'
			}, {
				value: 0,
				title: 'Tag styles',
				text: 'Each tag in the family has its own colours.'
			}]

		},

		contextOptions: function() {

			var options = [{
				value: this.$CONSTANTS.TAG.CONTEXT.GAME,
				title: 'Game',
				text: 'The tags in this family are attached to games and will be shown whenever the game appears in your profile.'
			}]

			if (this.data.filter === 'collection') {

				options.push({
					value: this.$CONSTANTS.TAG.CONTEXT.COLLECTION,
					title: 'Collection',
					text: 'The tags in this family are attached to collection entries and will not appear elsewhere.'
				})

			} else if (this.data.filter === 'ratings') {

				options.push({
					value: this.$CONSTANTS.TAG.CONTEXT.RATING,
					title: 'Rating',
					text: 'The tags in this family are attached to rating entries and will not appear elsewhere.'
				})

			} else if (this.data.filter === 'plays') {

				options.push({
					value: this.$CONSTANTS.TAG.CONTEXT.PLAY,
					title: 'Play',
					text: 'The tags in this family are attached to play entries and will not appear elsewhere.'
				})

			}

			return options

		}

	},

	methods: {

		onConfirmClick: function() {

			if (this.inputs.name) {

				this.is.loading = true

                this.$api.post('tags/family/create', {
					data: this.inputs
				}).then(function(family) {

					this.$store.commit('data/tagFamilies/add', [family])

					this.$emit('close')

					this.$pubsub.$emit('open.modal', {
						id: 'tagFamilyManage',
						family: family.id
					})

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this)) 

			}

		},

		onClose: function() {

			this.$emit('close')

			if (this.data.manage) {

				this.$pubsub.$emit('open.modal', 'tagManage')

			}	

		}

	}

}

</script>

<style scoped>

</style>